import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './MyComponents/Header';
import Footer from './MyComponents/Footer';
import Home from './MyComponents/pages/Home';
import AboutUs from "./MyComponents/pages/AboutUs";
import ContactUs from "./MyComponents/pages/ContactUs";
import Products from "./MyComponents/pages/Products";
import HamburgerMenu from './MyComponents/pages/HamburgerMenu';

function App() {
  return (
    <Router>
      <Header />
      <main style={{ minHeight: '100vh'}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/new-try" element={<HamburgerMenu />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
